<template>
<div class="description_ellipsis">
  <el-popover
    placement="top"
    width="550"
    v-if="isEllipsis"
    :content="content"
    trigger="hover">
      <div class="text_elliosis" slot="reference">
        {{subText(content)}}
      </div>
  </el-popover>
  <div v-else :class="[{'is-line': isLine}, {'text-break': !isLine}]" :title="content">{{content}}</div>
</div>
</template>

<script>
export default {
  name: 'v-text-ellipsis',
  props: {
    content: {
      type: String
    },
    limit: {
      type: Number,
      default: 50
    },
    emptyText: String,
    isLine: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isEllipsis () {
      return this.content && this.content.length > this.limit
    }
  },
  methods: {
    subText (str = '') {
      if (str) {
        return str.substr(0, this.limit).concat('...')
      } else if (!str && this.emptyText) {
        return emptyText
      } else {
        return str
      }
    }
  }
}
</script>

<style lang="less">
.description_ellipsis {
  display: inline-block;
  max-width: 100%;
  line-height: initial;
  vertical-align: middle;
  span {
    display: inline-block;
    width: 100%;
  }
  .text_elliosis {
    width: 100%;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .is-line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .text-break { // 防止超长数字溢出
    word-break: break-all;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/framework/detail/ellipsis.vue